import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Badge, Dropdown } from "react-bootstrap";
import Select from "react-select";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker, { DateObject } from "react-multi-date-picker";
import Drawer from '@mui/material/Drawer';
import vehicle from '../../../../images/vehicle/default_machinery.png';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';

import axios from 'axios';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
        diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff));
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
        diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const Machinery = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.toastMessage) {
            const type = location.state.toastType === 'success' ? toast.success : toast.error;
            type(location.state.toastMessage);
            // ✅ Clear location state so it doesn't show again on refresh
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);

    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/manage_machinery`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };
    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    const tableRef = useRef(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const DeleteModal = (data) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Machinery
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${data.machinery_name}</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${baseURL}/manage_machinery/${data.sno}`)
                    .then((response) => {
                        softRefresh();
                        toast.success("Vehicle Deleted Successfully!");
                    }).catch(error => {
                        onClose();
                        console.log(error);
                        toast.error("Vehicle Deletion Failed");
                    });
            }
        });
    };

    const vehicle_ctg = [
        { value: "1", label: "Power" },
        { value: "2", label: "Heating" },
        { value: "3", label: "Mixing" },
        { value: "4", label: "Cooling" },
    ];

    const vehicle_purpose = [
        { value: "1", label: "Production" },
        { value: "2", label: "Utility" },
        { value: "3", label: "Packaging" },
        { value: "4", label: "Others" }
    ];

    const vehicle_category = [
        { value: "0", label: "All" },
        { value: "1", label: "Van" },
        { value: "2", label: "Bike" },
        { value: "3", label: "EV" },
    ];
    const fuel_type = [
        { value: "0", label: "All" },
        { value: "1", label: "Petrol" },
        { value: "2", label: "Diesel" },
        { value: "3", label: "Electric" },
    ];
    const veh_purpose = [
        { value: "0", label: "All" },
        { value: "1", label: "Delivery" },
        { value: "2", label: "Office Work" },
        { value: "3", label: "Others" },
    ];
    const onClose = () => {
        setFilterOpen(false);
    };

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(new Date());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(new Date());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custum Date" }
    ];

    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }

    // status change
    const handleStatusToggle = async (id, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
        axios.put(`${baseURL}/manage_machinery/status/${id}`, { status: newStatus })
            .then(response => {
                softRefresh();
                toast.success("Status Updated Successfully!");
            })
            .catch(error => {
                console.log(error);
                toast.error("Status Updation Failed");
            });
    };


    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Machinery</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Maintanence Management</li>
                    </ol>
                </div>
                <div className='d-flex align-items-center gap-3 mb-2'>
                    {/* <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link> */}
                    {/* <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className='me-2'><i class="fa-solid fa-circle-down fs-8"></i></span>
                            <span className=''>Export</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="#" className='px-2'>
                                <img
                                    src={csv_ico}
                                    alt="CSV"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                            </Dropdown.Item>
                            <Dropdown.Item href="#" className='px-2'>
                                <img
                                    src={excel_ico}
                                    alt="Excel"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                            </Dropdown.Item>
                            <Dropdown.Item href="#" className='px-2'>
                                <img
                                    src={print_ico}
                                    alt="Print"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
                    <Link to={"/manage-machinery-add"} className="btn btn-primary float-end btn-sm" >
                        <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                        <span className=''>Add Machinery</span>
                    </Link>
                    
                </div>
            </div>

            <div className="table-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{ fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{ fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>

                <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>Machinery</th>
                            <th className='min-w-100px'>Brand / Purchase Date</th>
                            <th className='min-w-100px'>Serial Number / Purpose</th>
                            <th className='min-w-100px'>Maintenance Date</th>
                            <th className='min-w-50px'>Status</th>
                            <th className='min-w-80px'>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {datas.length === 0 && hasFetched ? (
                            <tr>
                                <td colSpan="6" className="text-center text-muted py-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            <>
                                {datas.map((data, index) => (
                                    <tr key={data.sno}>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={(imgBaseUrl && data.machinery_image) ? imgBaseUrl + '/' + data.machinery_image : vehicle} className='border rounded px-1 py-0'>
                                                        <img src={(imgBaseUrl && data.machinery_image) ? imgBaseUrl + '/' + data.machinery_image : vehicle} alt={data.machinery_name} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <OverlayTrigger
                                                        trigger={['hover', 'focus']}
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip className="tooltip-popover">
                                                                <span className="fs-8 text-white">Machinery Name</span>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <label className='text-black font-w400 fs-7'>{data.machinery_name}</label>
                                                    </OverlayTrigger>

                                                    <div className="d-block">
                                                        <OverlayTrigger
                                                            trigger={['hover', 'focus']}
                                                            placement="bottom"
                                                            overlay={
                                                                <Tooltip className="tooltip-popover">
                                                                    <span className="fs-8 text-white">Category</span>
                                                                </Tooltip>
                                                            }
                                                        ><label className="fs-8 text-dark font-w600">{data.category_name ? data.category_name : ''}</label></OverlayTrigger>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{data.brand_name}</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-dark font-w600">{formatDate(data.purchase_date)}</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{data.serial_number}</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-dark font-w600">{data.machinery_purpose ? vehicle_purpose.find(val => val.value == data.machinery_purpose).label : ''}</label>
                                            </div>
                                        </td>
                                        <td>
                                            <Badge bg="info" className='text-white fs-7 py-0 px-1'>{formatDate(data.upcoming_maintenance)}</Badge>
                                        </td>
                                        <td>
                                            <div className="form-check form-switch d-flex align-items-center mb-3">
                                                <input className="form-check-input me-2" type="checkbox" role="switch" defaultChecked={data.status === 0} onChange={() => handleStatusToggle(data.sno, data.status)} />
                                            </div>
                                        </td>
                                        <td>
                                            <span class="text-end">

                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                    <Link to={`/manage-machinery-view?data=${data.sno}`}>
                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                                            <span><i class="fa fa-eye fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </Link>
                                                </OverlayTrigger>

                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                    <Link to={`/manage-machinery-edit?data=${data.sno}`}>
                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" >
                                                            <span><i class="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </Link>
                                                </OverlayTrigger>

                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => DeleteModal(data)}>
                                                        <span><i class="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                                    </Button>
                                                </OverlayTrigger>
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {datas.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {totalPages * perPage - (perPage - datas.length)} entries
                            </span>
                        ) : (
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                </div>
            </div>

        </>
    )


}
export default Machinery;